import { Organization, User } from '../store/types';
import { UserRole } from 'susy-common/models';
import { UserRoles } from './utils';
import { ExternalSupervisorInvitationStatus } from '../definitions/enums/externalSupervisorInvitation';

export interface IUserRoleLocalization {
    Admin: string;
    Supervisor: string;
    User: string;
    external?: string;
}

export const getLocalizedUserRoleName = (
    userRole: UserRole,
    localization: IUserRoleLocalization
): string => {
    if (!userRole?.key) {
        return '';
    }

    switch (userRole.name) {
        case UserRoles.admin: {
            return localization.Admin;
        }
        case UserRoles.supervisor: {
            return localization.Supervisor;
        }
        case UserRoles.user: {
            return localization.User;
        }
        default: {
            return '';
        }
    }
};

export const getUserOrganizations = (user: User): Organization[] => {
    const userOrganizations = [
        ...(user.faculties ?? []),
        ...(user.programs ?? []),
        ...(user.intakes ?? []),
        ...(user.departments ?? []),
        ...(user.supervisorGroups ?? []),
    ];

    return userOrganizations;
};

export const userIsExternalSupervisor = (user: User) => {
    if (!user) {
        return false;
    }

    if (
        user.userRole?.name === UserRoles.admin ||
        user.userRole?.name === UserRoles.user
    ) {
        return false;
    }

    if (user.isExternalSupervisor) {
        return true;
    }

    const userIsInvitedExternalSupervisorButNotYetApproved =
        user.isExternalSupervisor === false &&
        user.externalSupervisorInvitation?.status ===
            ExternalSupervisorInvitationStatus.pending;
    if (userIsInvitedExternalSupervisorButNotYetApproved) {
        return true;
    }

    return false;
};
